// extracted by mini-css-extract-plugin
module.exports = {"specialBtn":"utilities_specialBtn__3FsWB","textMessage":"utilities_textMessage__3SufT","textMessage2":"utilities_textMessage2__PoFSu"};